import { Component, EventEmitter, Output } from '@angular/core';

/**
 * One-time "what's new" for the Settings merge: To Go, Payments and the
 * order / kitchen switches used to be three pages and are now sections of
 * Restaurant → Settings. The illustration is drawn in HTML/CSS rather than
 * screenshots so it follows the theme and can animate the three screens
 * folding into one. HomePageComponent decides when it shows and remembers
 * that it has been seen.
 */
@Component({
  selector: 'app-whats-new-settings-modal',
  standalone: true,
  templateUrl: './whats-new-settings-modal.component.html',
  styleUrl: './whats-new-settings-modal.component.css',
})
export class WhatsNewSettingsModalComponent {
  @Output() openSettings = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();

  /** Bumped by Replay: the stage is keyed on it, so the animation restarts. */
  run = 0;

  replay() {
    this.run++;
  }
}
